import { Fragment } from 'react'

import { useUkTimeZone } from '../../../hooks'
import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../Table'

import { renderCell } from './InhabitantTableRow.utils'

import * as styles from './InhabitantTableRow.module.css'

function InhabitantTableRow({
  Actions = TableRowActions,
  actionLeft,
  actionsColumnWidth,
  columns,
  context,
  emptyColumnSize,
  focusedRow,
  getActions,
  getOnClickProps,
  hideCheckbox,
  isResizing,
  isSelected,
  isShort,
  item,
  resizingColumn,
  scrollRef,
  showCellBorder,
  statuses,
  onChangeAddress,
  ...restProps
}) {
  const {
    handleCallAction,
    handleClick,
    handleMouseDown,
    handleMouseEnter,
    handleMouseLeave,
    handleSelect,
  } = useTableRowActions({ item, ...restProps }, { getOnClickProps })

  const ukTimeZone = useUkTimeZone()

  const { id } = item

  const qaProps = getTableRowQaProps()

  const className = useTableRowModClassName({
    className: styles.InhabitantTableRow,
    isActive: focusedRow === id,
    isSelected,
  })

  function handleChangeAddress() {
    onChangeAddress?.(item)
  }

  return (
    <div
      {...qaProps}
      className={className}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Actions ? (
        <Actions
          disabled={hideCheckbox}
          selected={isSelected}
          width={actionsColumnWidth}
          onChange={handleSelect}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            context,
            isActive: column.name === resizingColumn,
            isResizing,
            isShort,
            item,
            name: column.name,
            scrollRef,
            showCellBorder,
            statuses,
            ukTimeZone,
            width: column.width,
            onChangeAddress: handleChangeAddress,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
      {getActions?.(item).length > 0 ? (
        <TableRowContextActions
          actionLeft={actionLeft}
          focusedRow={focusedRow}
          getActions={getActions}
          item={item}
          onCallAction={handleCallAction}
        />
      ) : null}
    </div>
  )
}

export default InhabitantTableRow
